<template>
    <div v-if="isVisible" :class="['toast', 'show', `border-${variant}`]" :role="variant === 'danger' ? 'alert' : 'status'" aria-live="polite">
        <div class="toast-header">
            <slot name="title"><strong class="mr-auto">{{ title }}</strong></slot>
            <button type="button" class="ml-2 mb-1 close" aria-label="Close" @click="hide"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="toast-body"><slot>{{ message }}</slot></div>
    </div>
</template>
<script>
import { emitModel } from "./model";
export default {
    name: "SbToast",
    emits: ["update:modelValue", "show", "shown", "hide", "hidden"],
    props: {
        modelValue: { default: undefined },
        show: { type: Boolean, default: true },
        title: { type: String, default: null },
        message: { type: String, default: "" },
        variant: { type: String, default: "info" },
        autoHideDelay: { type: Number, default: 5000 },
        noAutoHide: { type: Boolean, default: false },
    },
    data() { const value = this.modelValue; return { isVisible: value === undefined ? this.show : Boolean(value), timer: null }; },
    watch: {
        modelValue(value) { if (value !== undefined) { this.setVisible(Boolean(value), false); } },
        show(value) { if (this.modelValue === undefined) { this.setVisible(value, false); } },
    },
    mounted() { if (this.isVisible) { this.startTimer(); this.$emit("shown"); } },
    beforeUnmount() { clearTimeout(this.timer); },
    methods: {
        setVisible(visible, emit = true) {
            if (visible === this.isVisible) { return; }
            this.$emit(visible ? "show" : "hide");
            this.isVisible = visible;
            if (emit) { emitModel(this, visible); }
            this.$nextTick(() => { this.$emit(visible ? "shown" : "hidden"); if (visible) { this.startTimer(); } });
        },
        startTimer() { clearTimeout(this.timer); if (!this.noAutoHide) { this.timer = setTimeout(() => this.hide(), this.autoHideDelay); } },
        hide() { this.setVisible(false); },
        open() { this.setVisible(true); },
    },
};
</script>
